import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { createHashHistory } from 'history'
import storage from 'redux-persist/es/storage'

import user from './user/reducers'
import register from './register/reducer'
import menu from './menu/reducers'
import settings from './settings/reducers'
import general from './general/reducer'

import dashboard from './dashboard/reducer'
import trades from './trades/reducer'
import newTrade from './newTrade/reducer'
import trade from './trade/reducer'
import chat from './chat/reducer'
import upload from './upload/reducer'
import beneficiary from './beneficiary/reducer'

import reports from './reports/reducers'
import notifications from './notifications/reducer'

import currencyAccounts from './currecnyAccounts/reducer'
import digitalPayment from './digitalPayment/reducer'
import caTransactions from './caTransactions/reducer'
import caBalanceAdjustments from './caBalanceAdjustments/reducer'

import idvScreening from './idvScreening/reducer'

const history = createHashHistory()

const appReducer = combineReducers({
  router: connectRouter(history),
  user,
  register,
  menu,
  settings,
  general,

  dashboard,
  trades,
  newTrade,
  trade,
  chat,
  upload,
  beneficiary,
  reports,
  notifications,
  currencyAccounts,
  digitalPayment,
  caTransactions,
  caBalanceAdjustments,

  idvScreening,
})

const rootReducer = (state, action) => {
  if (action.type === 'LOG_OUT') {
    state = {}
    storage.removeItem('persist:appReducer')
  }
  return appReducer(state, action)
}

export default rootReducer
